/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { useTranslation } from 'react-i18next'
import { Icon } from 'semantic-ui-react'

const orderStatusColors = {
    ACCEPTED: '#2185d0',
    CANCELLED: '#1B1C1D',
    COMPLETED: '#21BA45',
    DENIED: '#F2711C',
    EXPIRED: '#DB2828',
    PREPARING: '#6435c9',
    READY: '#B5CC18',
    RECEIVED: '#FBBD08',
}

const OrderFulfillmentProgress = ({order}) => {
    const [t] = useTranslation()
    const { status, containsOrderItemsAwaitingAction } = order
    const progressColor = containsOrderItemsAwaitingAction ? '#FBBD08' : orderStatusColors[order.status] || 'gray'

    return (
      <div
        css={css`
            position: relative;
            width: 100%;
            height: 1.5rem;
            background-color: ${progressColor};
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;
            overflow: hidden;
        `}
      >
          <span
            css={css`
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                color: white;
                font-weight: bold;
                z-index: 1;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            `}
          >
          {containsOrderItemsAwaitingAction ? (
            <div>
                <Icon name="user" />
                <Icon name="spinner" loading />
                {t('order.customerAckType.AWAITING_ACTION')}
            </div>
          ) : (
            t(`order.status.${status}`)
          )}
        </span>
      </div>
    )
}

export { OrderFulfillmentProgress }
